export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";